import React from "react"

import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"
import {
  Pagination,
  SliderArrow,
  SliderWrapper,
  Slides,
} from "~/components/SliderWrapper/SliderWrapper"

import styles from "./index.module.css"

type Props = {
  slides: { source: string; title: string }[]
  title: string
}

export const Gallery: React.FC<Props> = ({ slides, title }) => {
  return (
    <div className={styles.Wrapper}>
      <SliderWrapper
        className={styles.SliderWrapper}
        paginationType="fraction"
        params={{
          speed: 0,
          effect: "fade",
        }}
      >
        <>
          <Slides className={styles.SliderContainer} slideClassName={styles.Slide} slides={slides}>
            {({ source, title: description }) => {
              return (
                <div className={styles.SliderInner}>
                  <div className={styles.Image}>
                    <img src={source} />
                  </div>

                  <div className={styles.ColRight}>
                    {title && (
                      <Heading as="div" className={styles.Title} like="h3">
                        <Raw html={title} />
                      </Heading>
                    )}

                    {description && (
                      <div
                        className={styles.Description}
                        dangerouslySetInnerHTML={{ __html: description }}
                      />
                    )}
                  </div>
                </div>
              )
            }}
          </Slides>

          <div className={styles.Navigation}>
            <SliderArrow className={styles.ArrowLeft} direction="left" inCircle />
            <Pagination className={styles.Pagination} />
            <SliderArrow className={styles.ArrowRight} direction="right" inCircle />
          </div>
        </>
      </SliderWrapper>
    </div>
  )
}
